import React, { Component } from "react";
import {
  Grid,
  Header,
  Segment,
  Message,
  Button,
  Image,
} from "semantic-ui-react";
import { connect } from "react-redux";

import FormsSetupPassword from "../../component/forms/password/setup";
import { verifyAdminInvitation } from "../../actions";

import AppLogo from "../../component/logo";
class SetupPasswordPage extends Component {
  state = {
    loading: true,
    tokenValid: false,
    token: null,
    errorMessage: "",
  };

  componentDidMount() {
    const token = this.props.match.params.token;

    if (!token) {
      this.setState({
        loading: false,
        tokenValid: false,
        errorMessage:
          "Invalid invitation link. Please request a new invitation.",
      });
      return;
    }

    this.props.verifyAdminInvitation({ token }, (status, error) => {
      if (error) {
        const errorMessage =
          error.response?.data?.errorMessage ||
          "This invitation link has expired or is invalid. Please request a new invitation.";
        this.setState({
          loading: false,
          tokenValid: false,
          errorMessage,
        });
      } else {
        this.setState({ tokenValid: true, loading: false, token });
      }
    });
  }

  render() {
    const { loading, tokenValid, token, errorMessage } = this.state;

    if (loading) return null;

    return (
      <div className="login-form">
        <Grid
          textAlign="center"
          style={{ height: "100%" }}
          verticalAlign="middle">
          <Grid.Column style={{ maxWidth: 450 }}>
            <Header as="h1" textAlign="center">
              <Image
                src="https://mplify.mhcasia.net/mhc_logo.jpg"
                size="huge"
              />
            </Header>

            <Header as="h2" textAlign="center">
              Set Up Your Password
            </Header>

            <Segment stacked>
              {tokenValid ? (
                <FormsSetupPassword token={token} />
              ) : (
                <div>
                  <Message negative>
                    <Message.Header>Link Expired or Invalid</Message.Header>
                    <p>{errorMessage}</p>
                  </Message>
                  <Button
                    primary
                    fluid
                    onClick={() => {
                      window.location.href = "/password/reset";
                    }}>
                    Send Password Setup Email
                  </Button>
                  <Button
                    basic
                    fluid
                    style={{ marginTop: "10px" }}
                    onClick={() => {
                      window.location.href = "/";
                    }}>
                    Go to Login
                  </Button>
                </div>
              )}
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default connect(null, {
  verifyAdminInvitation,
})(SetupPasswordPage);
